export default {
      id: "timeline-usage",
      viewBox: "0 0 36 13",
      url: __webpack_public_path__ + "img/icons.svg#timeline",
      toString: function () {
        return this.url;
      }
    }